import { render } from "./RuiPageLayout.vue?vue&type=template&id=b4422eca&scoped=true"
import script from "./RuiPageLayout.vue?vue&type=script&lang=ts"
export * from "./RuiPageLayout.vue?vue&type=script&lang=ts"

import "./RuiPageLayout.vue?vue&type=style&index=0&id=b4422eca&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b4422eca"

export default script